import { toast } from "react-toastify";
import { BASE_URL } from "../util/constant";
export const postApi = async (path, payload) => {
  try {
    const res = await fetch(`${BASE_URL}/${path}`, {
      body: JSON.stringify(payload),
      method: "post",
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error, "error");
  }
};
